var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable react/jsx-no-bind */
import React, { useContext, useState } from 'react';
import { Card, Input, Button, Box, Flex } from 'pcln-design-system';
import { maskNumbersInMessage } from './travelBotDataMask';
import { ChatbotDataContext } from './context/ChatbotDataContext';
/**
 * DialogInputSection
 * Component for input and submit button
 * @public
 */
export var DialogInputSection = function (props) {
    var _a;
    var _b = useContext(ChatbotDataContext), setCachedMessages = _b.setCachedMessages, setCachedPrompts = _b.setCachedPrompts, logFirstMessageSubmitted = _b.logFirstMessageSubmitted;
    var _c = useState(''), inputValue = _c[0], setInputValue = _c[1];
    var isDisablingInput = props.isDisablingInput, isLoading = props.isLoading, chatMessages = props.chatMessages, setChatMessage = props.setChatMessage, setErrorMessage = props.setErrorMessage, submitInputValue = props.submitInputValue;
    var submit = function () {
        // mask sensitive info in there is any
        var content = maskNumbersInMessage(inputValue);
        // Clear the value inside input box
        setInputValue('');
        // Create a user message
        var msg = { role: 'user', content: content };
        // cache the msg on local for reuse
        setCachedMessages(msg);
        setCachedPrompts(msg);
        var updatedChatMessages = __spreadArray(__spreadArray([], chatMessages, true), [msg], false);
        // Update the message showing in the dialog
        setChatMessage(updatedChatMessages);
        // Set the error message as empty if there is any
        setErrorMessage('');
        // Submit the user message
        submitInputValue(msg, updatedChatMessages);
        // Log first message submit
        if (chatMessages.length <= 1 &&
            logFirstMessageSubmitted &&
            typeof logFirstMessageSubmitted === 'function') {
            logFirstMessageSubmitted(content);
        }
    };
    function keyUpHandler(event) {
        var _a;
        if (event.key === 'Enter' && !isLoading && !isDisablingInput && ((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.trim())) {
            submit();
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { bg: 'background.tint', width: 1, height: '1px' }),
        React.createElement(Flex, { p: 2, width: 1 },
            React.createElement(Card, { mr: 2, width: 'calc(100% - 90px)}', borderRadius: 24, boxShadowSize: 'sm' },
                React.createElement(Input, { disabled: isDisablingInput, style: {
                        backgroundColor: 'white',
                        borderStyle: 'none',
                        borderRadius: '24px',
                    }, id: 'chatInput', "data-testid": 'chatInput', value: inputValue, placeholder: 'Type your message here', onChange: function (event) {
                        event.preventDefault();
                        var target = event.target;
                        setInputValue(target.value);
                    }, onBlur: function (event) {
                        var _a;
                        event.preventDefault();
                        var target = event.target;
                        setInputValue(maskNumbersInMessage((_a = target.value) === null || _a === void 0 ? void 0 : _a.trim()));
                    }, onKeyUp: keyUpHandler })),
            React.createElement(Button, { "data-testid": 'submitChatInput', disabled: isDisablingInput || isLoading || !((_a = inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim()) === null || _a === void 0 ? void 0 : _a.length), onClick: function (event) {
                    event.preventDefault();
                    if (!isDisablingInput && !isLoading) {
                        submit();
                    }
                } }, "Submit"))));
};
//# sourceMappingURL=DialogInputSection.js.map